// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPhone_root__w2LRr","matterColorLightStroke":"IconPhone_matterColorLightStroke__G7RBQ"};